/**
 * Connection lifecycle status. Re-exported from the canonical definition in
 * aumico-lib-core-fe so the multi-vendor lib and the Bexio (companies) lib share
 * ONE status vocabulary. Keep importing `ConnectionStatus` from this path within
 * integrations-fe; it is the same symbol as `@modeso/aumico-lib-core-fe`.
 */
export { ConnectionStatus } from '@modeso/aumico-lib-core-fe';
